import styled, { css } from "styled-components";
import { Modal, Button } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

export const StyledButton = styled.button`
  width: 181px;
  height: 30px;
  border-radius: 8px;
  gap: 8px;
  background-color: rgba(17, 167, 217, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
  position: relative;
  left: -10px;

  &:hover {
    background-color: rgba(17, 150, 200, 1);
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 100%;
    font-size: 12px;
    height: 35px;
    padding: 10px;
  }

  ${({ header }) =>
    header &&
    css`
      position: unset;
      padding: 16px 4px;
      background-color: #06719e;

      &:hover {
        background-color: rgb(5, 93, 131);
        transform: scale(1) !important;
      }
    `}
`;

export const StyledModal = styled(Modal)`
  width: 658px !important;
  height: auto;

  .ant-modal-content {
    border-radius: 8px;
  }
  .ant-modal-header {
    border-bottom: none;
    border-radius: 8px;
    padding: 24px;
  }
  .ant-modal-body {
    padding: 24px;
    padding-top: 0;
  }
  .ant-modal-mask {
    z-index: 9999;
    background: rgba(0, 0, 0, 0.5);
  }

  .ant-modal-footer {
    padding: 24px;
    padding-top: 0;
    border-top: none;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 0 16px;
  }
`;

export const StyledDropdownButton = styled(Button)`
  width: 610px;
  height: 48px;
  border-radius: 10px;
  padding: 12px;
  border-width: 1.5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;

  @media (max-width: 768px) {
    width: 100%;
    font-size: 14px;
    height: 40px;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledFooterButton = styled(Button)`
  width: 98px;
  height: 38px;
  border-radius: 10px;
  padding-top: 8px;
  padding-right: 16px;
  padding-bottom: 8px;
  background: rgba(6, 142, 195, 1);
  font-size: 14px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  color: white;

  @media (max-width: 768px) {
    width: 100%;
    font-size: 12px;
    height: 35px;
  }
`;

export const StyledCancelButton = styled(Button)`
  height: 38px;
  border-radius: 10px;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid rgba(6, 142, 195, 1);
  font-size: 14px;
  font-weight: 600;
  font-family: "Inter", sans-serif;
  color: rgba(6, 142, 195, 1);

  &:hover,
  &:focus {
    background: #f5fbfe;
    border-color: rgba(6, 142, 195, 1);
    color: rgba(6, 142, 195, 1);
  }

  @media (max-width: 768px) {
    width: 100%;
    font-size: 12px;
    height: 35px;
  }
`;

export const TitleDropdown = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0px;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const ContentDropdown = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0px;
  color: rgba(104, 104, 110, 1);

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const StyledModalTitle = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 100%;
`;

export const StyledModalTitleContainer = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
  .circle {
    width: 36px;
    height: 36px;
    background: #f9f9fd;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
`;

export const StyledCheckCircle = styled(CheckCircleOutlined)`
  color: rgba(6, 142, 195, 1);
  font-size: 24px;
`;

export const SubCategoryField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FieldLabel = styled.span`
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: rgba(38, 38, 38, 1);

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SubCategoryTag = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 16px;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  transition: all 0.2s ease;
  border: 1.5px solid ${({ $selected }) => ($selected ? "#068ec3" : "#d9d9d9")};
  background: ${({ $selected }) => ($selected ? "#068ec3" : "#ffffff")};
  color: ${({ $selected }) => ($selected ? "#ffffff" : "#68686e")};
  font-weight: ${({ $selected }) => ($selected ? 600 : 400)};

  &:hover {
    border-color: #068ec3;
    color: ${({ $selected }) => ($selected ? "#ffffff" : "#068ec3")};
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const EmptySubCategoriesMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 12px;
  background-color: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 6px;
  color: #d46b08;
  font-size: 13px;
  line-height: 1.4;

  svg {
    flex-shrink: 0;
  }
`;
